/**
 * SelectionTintContext — broadcast a parent's selection state down the
 * scene-graph so child GLB consumers (mover-tool carriers, custom
 * assets bound to a mover) tint their own materials with the same
 * colour as the parent.
 *
 * Wired by `<XtsMover>` so when a mover is selected, every child
 * `<CustomAssetMesh>` underneath — AT8200 tools + custom assets —
 * picks up the highlight too. Modules don't need this because they
 * have no GLB-bound children today.
 */

import React from 'react';

export interface SelectionTintState {
  selected: boolean;
  color: string;
}

export const SelectionTintContext =
  React.createContext<SelectionTintState | null>(null);
